module.exports = "<div class=\"weui_grids\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/grids/grids.vue
 ** module id = 121
 ** module chunks = 0
 **/